<template>
  <div class="teamer">
    <div class="member-box">
      <ul class="member-list" v-if="members.length != 0">
        <li v-for="(item, key) in members" :key="key">
          <div
            class="head"
            :style="{
              'background-image': `url(${item.avatar ? item.avatar : ''})`
            }"
          ></div>
          <div class="name">
            <div class="label-box">
              <div class="label-shadow">{{ item.name ? item.name : '-' }}</div>
              <div class="label-text">{{ item.name ? item.name : '-' }}</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="data-box">
      <ul class="header">
        <li v-for="(item, key) in header" :key="key" :name="item.key">
          <div class="item">
            <div class="bg"></div>
            <div class="label-box">
              <span class="label-shadow">{{ item.name }}</span>
              <span class="label-text">{{ item.name }}</span>
            </div>
          </div>
        </li>
      </ul>
      <ul class="data-list">
        <li v-for="(member, key) in members" :key="key">
          <ol>
            <li name="name">{{ member['name'] ? member['name'] : '-' }}</li>
            <li name="playerAvgKill">
              {{ member['playerAvgKill'] | nullValue }}
            </li>
            <li name="playerAvgAccuracy">
              {{ member['playerAvgAccuracy'] | nullValue | percentage }}
            </li>
            <li name="playerAvgDamage">
              {{ member['playerAvgDamage'] | nullValue }}
            </li>
            <li name="playerAvgSurvialTime">
              {{ member['playerAvgSurviveTime'] | nullValue | time }}
            </li>
            <li name="playerAvgTravelDistance">
              {{ member['playerAvgTravelDistance'] | nullValue | distance }}
            </li>
            <li name="playerTotalKill">
              {{ member['playerTotalKill'] | nullValue }}
            </li>
          </ol>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    subTeam: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    subTeam(newVal) {
      this.getMembersInfo(newVal)
    }
  },
  data() {
    return {
      members: [],
      header: [
        { key: 'name', name: '队员' },
        { key: 'playerAvgKill', name: '场均淘汰' },
        { key: 'playerAvgAccuracy', name: '命中率' },
        { key: 'playerAvgDamage', name: '场均伤害' },
        { key: 'playerAvgSurvialTime', name: '场均存活' },
        { key: 'playerAvgTravelDistance', name: '场均位移' },
        { key: 'playerTotalKill', name: '淘汰总数' }
      ]
    }
  },
  filters: {
    nullValue: function (value) {
      return value || value === 0 ? Math.round(value) : '-'
    },
    percentage: function (value) {
      return value !== '-' ? `${value}%` : value
    },
    time: function (value) {
      return value !== '-' ? `${Math.floor(value / 60)}m${value % 60}s` : value
    },
    distance: function (value) {
      return value !== '-' ? `${(value / 1000).toFixed(2)}km` : value
    }
  },
  mounted() {
    this.getMembersInfo()
  },
  methods: {
    getMembersInfo(data = {}) {
      //  这里读取不到 subTeam
      let subTeam = this.$route.params.subTeam
      if (subTeam) {
        if (
          Object.keys(subTeam).length != 0 &&
          subTeam.playerLists &&
          subTeam.playerLists.length != 0
        ) {
          this.members = subTeam.playerLists
        }
      } else {
        if (
          Object.keys(data).length != 0 &&
          data.playerLists &&
          data.playerLists.length != 0
        ) {
          this.members = data.playerLists
        }
      }

      let memberLength = this.members.length;
      if(memberLength <= 5) {
        for(let i = 0; i < 5 - memberLength; i++) {
        this.members.push({
            avatar: 'https://website.xdcdn.net/poster/58881/20250717/KMiYBaDu.png',
            name: '待补充成员'
          })
        }
      }
      
      // 埋点
      if (typeof tapdb == 'undefined') return
      tapdb.trackEvent('队员详情', {
        '#team_id': subTeam?.name
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/teams/detail-teamer';
</style>